import { render, staticRenderFns } from "./fanxy.vue?vue&type=template&id=1d9a1cd6&scoped=true&"
import script from "./fanxy.vue?vue&type=script&lang=js&"
export * from "./fanxy.vue?vue&type=script&lang=js&"
import style0 from "./fanxy.vue?vue&type=style&index=0&id=1d9a1cd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a1cd6",
  null
  
)

export default component.exports